import { useMemo } from 'react';
import { useSession } from '@sdk/session/SessionContext';

import sentMessageWAV from '@web/assets/sounds/SentMessage.wav';

const noop = () => void 0;

export const useSoundNotification = () => {
  const {
    currentUser: {
      settings: { playSound },
    },
  } = useSession();

  const messageSent = useMemo(() => {
    if (!playSound) return noop;

    return () => {
      const player = new Audio(sentMessageWAV);
      player.play();
    };
  }, [playSound]);

  return { messageSent };
};
